var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "migrationBanner" },
    [
      _vm.ShowMigrationBannerEnabled
        ? _c(
            "b-row",
            [
              _c(
                "b-alert",
                {
                  staticClass: "flex-grow-1 w-100",
                  attrs: {
                    show: _vm.ShowMigrationBannerEnabled,
                    variant: "info"
                  }
                },
                [
                  _c("h5", [
                    _c("i", { staticClass: "far fa-info-circle fa-lg" }),
                    _vm._v(" " + _vm._s(_vm.$t("xMigrationBannerHeaderText")))
                  ]),
                  _c("p", { staticClass: "bannerBody ml-4" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("xMigrationBannerBodyText")) + " "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "p-0 fw-bold learnMore hoverPointer",
                        on: {
                          click: function($event) {
                            return _vm.$bvModal.show("migration-info-modal")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("xLearnMoreLowercase")) + ".")]
                    )
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            id: "migration-info-modal",
            centered: "",
            "hide-footer": ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c(
                    "b-row",
                    {
                      staticClass: "w-100 justify-content-between py-0",
                      attrs: { "align-v": "center", "no-gutters": "" }
                    },
                    [
                      _c("h2", { staticClass: "modal-title" }, [
                        _c("i", { staticClass: "far fa-info-circle fa-md" }),
                        _vm._v(" " + _vm._s(_vm.$t("xUpgradeYourExperience")))
                      ]),
                      _c(
                        "b-button",
                        {
                          staticClass:
                            "btn btn-icon-button btn-icon-button--gray",
                          on: {
                            click: function($event) {
                              return _vm.$bvModal.hide("migration-info-modal")
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("xMigrationBannerLearnMoreModalIntro")))
            ]),
            _c(
              "ul",
              _vm._l(7, function(n) {
                return _c("li", { key: n }, [
                  _vm._v(
                    _vm._s(_vm.$t(`xMigrationBannerLearnMoreModalItem${n}`))
                  )
                ])
              }),
              0
            ),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("xMigrationBannerLearnMoreModalOutro")))
            ])
          ]),
          _c(
            "div",
            { staticClass: "w-100 align-items-start mt-3" },
            [_c("MobileDownloadLinkButtons")],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }